/**
 * ReviewsIcon/index.js
 * desc: review feature main navigation icon
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const ReviewsIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="reviews icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.reviews.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 20 22" xmlns="http://www.w3.org/2000/svg"><path d="M12.1 2.2C12.1.99 11.11 0 9.9 0 8.69 0 7.7.99 7.7 2.2c0 1.21.99 2.2 2.2 2.2 1.21 0 2.2-.99 2.2-2.2zm1.1 5.5h6.6V5.5H0v2.2h6.6V22h2.2v-6.6H11V22h2.2V7.7z"/></svg>
    </IconButton>
);


export default ReviewsIcon;
